// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"myNews_wrapper_mAxQh","line":"myNews_line_37jgl","empty":"myNews_empty_2_zMv","btn":"myNews_btn_17kXT","nomore":"myNews_nomore_18rDK"};